import PropTypes from 'prop-types'

import { ElectricVehicleProfileScopeTypes } from '../../models/electric/electric-vehicle-profile-scope-enum.js'
import { idPropType } from '../common/id-prop-type.js'
import { energyConsumptionForSpeedPropType } from './energy-consumption-for-speed-prop-type.js'

/**
 * @typedef {Object} ElectricVehicleEnergyConsumptionProfile
 *
 * @property {Array<EnergyConsumptionForSpeed>} - The electric vehicle energy consumption characteristics array
 * @property {string} dataScope - The scope of the energy consumptions entries. Values may be calculated basing on single object when enough data and for whole generation
 * @property {string} objectId - The object id unique identifier
 */
export const electricVehicleEnergyConsumptionProfilePropType = PropTypes.shape({
    energyConsumptionForConstantSpeed: PropTypes.arrayOf(energyConsumptionForSpeedPropType),
    dataScope: PropTypes.oneOf(Object.values(ElectricVehicleProfileScopeTypes)).isRequired,
    objectId: idPropType.isRequired
})
